import type { Event } from '@patsnap/tahiti-core';

/**
 * 报告生成状态服务。
 *
 * 仅在报告结果数据刷新完成后才会进入已生成状态并发出通知。
 */
export interface ReportGenerationStatusService {
    /** 报告结果数据是否已经刷新完成。 */
    readonly isReportGenerated: boolean;
    /** 报告结果数据刷新完成事件。 */
    readonly onReportGenerated: Event<void>;
}

/** 报告生成状态服务的容器标识。 */
export const ReportGenerationStatusService = Symbol('ReportGenerationStatusService');
